module.exports = "pegasus/assets/themelp1/design/101.png";